import Events from "events";

export default new Events.EventEmitter();
